import { COMPOSIO_INTEGRATION_DEFINITIONS } from "@frontend-shared/constants";
import type {
  IGlobalSearchIntegrationProviderCandidate,
  TGlobalSearchTranslate,
} from "@frontend-shared/types";
import { useMemo } from "react";

import { useGetEnabledIntegrations } from "@/api/integration/useGetEnabledIntegrations";

interface IUseGlobalSearchIntegrationProvidersProps {
  isEnabled: boolean;
  translate: TGlobalSearchTranslate;
}

const INTEGRATION_NAMESPACE = "integration";

// NOTE: NSAI-6589 — the connectors the Integrations page lists for this project:
// enabled for the deployment and, for an organization-scoped connector, set up
// by the organization (use-integration.ts applies the same two filters).
export const useGlobalSearchIntegrationProviders = ({
  isEnabled,
  translate,
}: IUseGlobalSearchIntegrationProvidersProps): IGlobalSearchIntegrationProviderCandidate[] => {
  const { data: enabledIntegrations, enabledProviderInfo } =
    useGetEnabledIntegrations(isEnabled);

  return useMemo(
    () =>
      COMPOSIO_INTEGRATION_DEFINITIONS.filter(
        (definition) =>
          enabledIntegrations.includes(definition.id) &&
          enabledProviderInfo.get(definition.id)?.isOrgConfigured !== false,
      ).map((definition) => ({
        id: definition.id,
        name: translate(`${INTEGRATION_NAMESPACE}:${definition.nameKey}`),
        description: translate(
          `${INTEGRATION_NAMESPACE}:${definition.descriptionKey}`,
        ),
      })),
    [enabledIntegrations, enabledProviderInfo, translate],
  );
};
